var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"administrarInstructivoEmbarque"}},[_c('ui-modal',{ref:"modal",attrs:{"title":"Administrar Instructivo de embarque"},on:{"close":function($event){_vm.ActionSetZindexTablaModal(false); _vm.actionSetAbrirAgregarInstructivoEmbarque(false)}}},[_c('h6',[_vm._v("Hooola mundo")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }